export async function saveOrder(order) {
    return window.axios.post('orders', order);
}

export async function fetchOrders() {
    return window.axios.get('orders');
}


export async function rejectOrders(order) {
    return window.axios.post(`orders/${order.id}/decline`);
}

export async function approveOrders(order) {
    return window.axios.post(`orders/${order.id}/approve`);
}
export async function contactUs(message) {
    return window.axios.post(`contact_us`,message);
}
